import { GrafanaUrl } from "../../api/constants";
import { isTest } from "../../api/services/httpRequests";

export const idParam = ":id";
export const nameParam = ":name";

export const resetPasswordPageUrlResult = `/reset-result`;
export const recoverPageUrlResult = `/recover-result`;
export const mainUrl = `/`;
export const profileUrl = `/profile`;
export const loginPageUrl = `/login`;
export const resetPasswordPageUrl = `/recover`;
export const recoverPageUrl = `/auth/recover/end`;
export const createInstallerPageUrl = `/installers/new`;
export const createCustomerPageUrl = `/customers/new`;
export const customersListPageUrl = `/customers`;
export const installersListPageUrl = `/installers`;
export const updateUserPageUrl = (id: string) => `/users/update/${id}`;
export const updateInstallerPageUrl = (id: string) =>
  `/installers/update/${id}`;
export const createSubscriptionPageUrl = `/subscriptions/new`;
export const installationPageUrl = (id: string) => `/installations/${id}`;
export const subscriptionsListToInstallationPageUrl = `/data/subscriptions`;
export const installationListToLineChartUrl = (id: string) =>
  `/data/subscriptions/${id}/installations`;
export const subscriptionsListToUpdateUrl = `/subscriptions/update`;
export const updateSubscriptionUrl = (id: string) =>
  `/subscriptions/update/${id}`;
export const subscriptionsListToDataHistoryPageUrl = `/history/subscriptions`;
export const installationListToDataHistoryUrl = (id: string) =>
  `/history/subscriptions/${id}/installations`;
export const dataHistoryPanelUrl = (id: string) =>
  `/history/subscriptions/installations/${id}`;
export const createInstallationUrl = `/new_installation`;
export const installersAssociationsUrl = `/subscriptions/installers`;
export const installationsListToUpdateUrl = `/subscriptions/installations`;
export const updateInstallationUrl = (id: string) =>
  `/installations/${id}/update`;
export const alarmsPageUrl = `/alarms`;
export const campaignPageUrl = `/dashboard/qdc/home`;
export const deviceConnectionConfigurationUrl = (id: string) =>
  `/installations/${id}/configuration`;
export const updateDeviceConnectionConfigurationUrl = (id: string) =>
  `/installations/${id}/configuration/update`;
export const successConfigurationUrl = (id: string) =>
  `/installations/${id}/configuration/success`;
export const technicalTestingUrl = (id: string) =>
  `/installations/${id}/testing`;
export const selectTestsUrl = (id: string) => `/installations/${id}/select`;
export const adminPanelIconsUrl = `/adminpanel`;
export const installerPanelIconsUrl = `/installerpanel`;
export const configurationAlarmsPageUrl = (id: string) =>
  `/${id}/alarms/configuration`;
export const updateAlarmPageUrl = (id: string, name: string) =>
  `/alarms/${id}/update/${name}`;
export const signalConfigurationUrl = (id: string) =>
  `/${id}/signal/configuration`;
export const updateSignalConfigurationUrl = (id: string) =>
  `/${id}/signal/configuration/update`;
export const alarmConfigurationUrl = (id: string) =>
  `/${id}/alarm/configuration`;
export const irrigationConfigurationUrl = (id: string) =>
  `/${id}/irrigation/configuration`;
export const irrigationConfigurationCustomerUrl = `/irrigation/configuration/customer`;
export const testingConfigurationUrl = (id: string) =>
  `/${id}/testing/configuration`;
export const testingUrl = (id: string) => `/${id}/testing/start`;
export const updateAlarmConfigurationUrl = (
  device_id: string,
  alarm_id: string
) => `/${device_id}/alarm/${alarm_id}/configuration`;
export const subscriptionsListToWifiUrl = `/wifi/subscriptions`;
export const installationsListToWifiUrl = (id: string) =>
  `/wifi/subscriptions/${id}/installations`;
export const installationWifiUrl = (id: string) => `/wifi/installations/${id}`;
export const deviceConfigurationUrl = `/device_configuration/installations`;
export const subscriptionsListToLogsUrl = `/logs/subscriptions`;
export const installationsListToLogsUrl = (id: string) =>
  `/logs/subscriptions/${id}/installations`;
export const logsUrl = (id: string) => `/logs/installations/${id}`;
export const calibrationUrl = (id: string) =>
  `/subscriptions/installations/${id}/calibration`;

export const routes = {
  mainPage: mainUrl,
  adminPanel: adminPanelIconsUrl,
  configuratorPanel: installerPanelIconsUrl,
  login: loginPageUrl,
  recoverStart: resetPasswordPageUrl,
  recoverEnd: recoverPageUrl,
  resetResult: resetPasswordPageUrlResult,
  recoverResult: recoverPageUrlResult,
  profile: profileUrl,
  addInstaller: createInstallerPageUrl,
  addCustomer: createCustomerPageUrl,
  installationPage: installationPageUrl(idParam),
  customersList: customersListPageUrl,
  installersList: installersListPageUrl,
  updateUser: updateUserPageUrl(idParam),
  updateInstaller: updateInstallerPageUrl(idParam),
  installationsListToLineChart: installationListToLineChartUrl(idParam),
  installationsListToDataHistory: installationListToDataHistoryUrl(idParam),
  addSubscription: createSubscriptionPageUrl,
  subscriptionsListToUpdate: subscriptionsListToUpdateUrl,
  updateSubscription: updateSubscriptionUrl(idParam),
  subscriptionsListToDataHistory: subscriptionsListToDataHistoryPageUrl,
  dataHistoryPanel: dataHistoryPanelUrl(idParam),
  subscriptionsListToInstallationPage: subscriptionsListToInstallationPageUrl,
  installersAssociations: installersAssociationsUrl,
  addInstallation: createInstallationUrl,
  installationsListToUpdate: installationsListToUpdateUrl,
  updateInstallation: updateInstallationUrl(idParam),
  alarms: alarmsPageUrl,
  campaignPage: campaignPageUrl,
  deviceConnectionConfiguration: deviceConnectionConfigurationUrl(idParam),
  updateDeviceConnectionConfiguration:
    updateDeviceConnectionConfigurationUrl(idParam),
  successConfiguration: successConfigurationUrl(idParam),
  technicalTesting: technicalTestingUrl(idParam),
  selectTests: selectTestsUrl(idParam),
  alarmsConfiguration: configurationAlarmsPageUrl(idParam),
  alarmsUpdate: updateAlarmPageUrl(idParam, nameParam),
  signalConfiguration: signalConfigurationUrl(idParam),
  updateSignalConfiguration: updateSignalConfigurationUrl(idParam),
  alarmConfiguration: alarmConfigurationUrl(idParam),
  irrigationConfiguration: irrigationConfigurationUrl(idParam),
  irrigationConfigurationCustomer: irrigationConfigurationCustomerUrl,
  testConfiguration: testingConfigurationUrl(idParam),
  testing: testingUrl(idParam),
  updateAlarmConfiguration: updateAlarmConfigurationUrl(idParam, nameParam),
  subscriptionsListToWifi: subscriptionsListToWifiUrl,
  installationsListToWifi: installationsListToWifiUrl(idParam),
  installationWifi: installationWifiUrl(idParam),
  deviceConfiguration: deviceConfigurationUrl,
  subscriptionsListToLogs: subscriptionsListToLogsUrl,
  installationsListToLogs: installationsListToLogsUrl(idParam),
  installationLogs: logsUrl(idParam),
  calibration: calibrationUrl(idParam),
};

export const roles = {
  admin: "admin",
  installer: "installer",
  customer: "customer",
};

export const tabList = [
  {
    key: "avg",
    tab: "Media",
  },
  {
    key: "sum",
    tab: "Somma",
  },
];

export const lineColors = {
  sum: "#8884D8",
  avg: "#8884D8",
  min: "#008000",
  max: "#FF6347",
};

export const checkbox = [
  { label: "avg", value: "avg" },
  { label: "max", value: "max" },
  { label: "min", value: "min" },
];

export const rowsPerTablePage: number = 15;
export const refreshTime: string = isTest
  ? "30s"
  : window._env_.DASHBOARD_REFRESH_TIME!; // 30s

export const enDashboardUrl: string = isTest
  ? " /d/mate_xt_40/single_device?orgId=1&kiosk=tv&var-device_id="
  : window._env_.DASHBOARD_URL_EN!;
export const itDashboardUrl: string = isTest
  ? " /d/mate_xt_40/single_device?orgId=1&kiosk=tv&var-device_id="
  : window._env_.DASHBOARD_URL_IT!;

export const model1: string = "model_1";
export const enUrl: (id: string) => string = (id) =>
  `${GrafanaUrl}${enDashboardUrl}${id}&refresh=${refreshTime}`;
export const itUrl: (id: string) => string = (id) =>
  `${GrafanaUrl}${itDashboardUrl}${id}&refresh=${refreshTime}`;

export const dashboardPumpUrl = (id: string, config: any) => {
  let url = `https://grafana.app.nurset.it/d/uCnWioqXc/ss2_clone_per_test_variabili?orgId=1&kiosk=tv&var-device_id=${id}&refresh=30s`;

  // Funzione helper per aggiungere la variabile all'URL
  const addVar = (varName: string, configKey: string | boolean) => {
    let value: boolean;

    if (typeof configKey === 'boolean') {
      value = configKey; 
    } else {
      value = config?.[configKey] !== false;
    }

    url += `&var-${varName}=${value ? 'true' : 'false'}`;
  };

  // t → tint_enabled
  addVar('t', 'tint_enabled');

  // w_dir → wdir_enabled
  addVar('w_dir', 'wdir_enabled');

  // m_pul → sempre true
  addVar('m_pul', true);

  // w_spd → wvel_enabled
  addVar('w_spd', 'wvel_enabled');

  // curr → coil_enabled
  addVar('curr', 'coil_enabled');

  // p_pre → ppref_enabled
  addVar('p_pre', 'ppref_enabled');

  // p_pos → ppostf_enabled
  addVar('p_pos', 'ppostf_enabled');

  // fert → flvl_enabled
  addVar('fert', 'flvl_enabled');

  // h → hint_enabled
  addVar('h', 'hint_enabled');

  // p → patm_enabled
  addVar('p', 'patm_enabled');

  return url;
};
export const dashboardActuatorUrl = (id: string) =>
  `https://grafana.app.nurset.it/d/9FzDVzyVk/ss4?orgId=1&kiosk=tv&var-device_id=${id}&refresh=30s`; // OKK
export const dashboardPlantUrl = (id: string, config: any) => {
  // OLD `https://grafana.app.nurset.it/d/DZg-Gky4k/nurset?orgId=1&kiosk=tv&var-device_id=${id}&refresh=30s`;
  let url = `https://grafana.app.nurset.it/d/DZg-Gky3d/ss1_clone_per_test_variabili?orgId=1&kiosk=tv&var-device_id=${id}&refresh=30s`;

  // Funzione helper per aggiungere la variabile all'URL
  const addVar = (varName: string, configKey: string) => {
    const value = config?.[configKey];
    if (value === false) {
      url += `&var-${varName}=false`;
    } else {
      url += `&var-${varName}=true`;
    }
  };

  // hsoil
  addVar('hsoil1', 'hsoil1_enabled');
  addVar('hsoil2', 'hsoil2_enabled');
  addVar('hsoil3', 'hsoil3_enabled');
  addVar('hsoil4', 'hsoil4_enabled');

  // tsoil
  addVar('tsoil1', 'tsoil1_enabled');
  addVar('tsoil2', 'tsoil2_enabled');
  addVar('tsoil3', 'tsoil3_enabled');
  addVar('tsoil4', 'tsoil4_enabled');

  // ecsoil
  addVar('ecsoil1', 'ecsoil1_enabled');
  addVar('ecsoil2', 'ecsoil2_enabled');
  addVar('ecsoil3', 'ecsoil3_enabled');
  addVar('ecsoil4', 'ecsoil4_enabled');

  // ev, batt, solar
  addVar('ev', 'ev_enabled');
  addVar('batt', 'batt_enabled');
  addVar('solar', 'solar_enabled');

  // t, h, p
  addVar('t', 'tint_enabled');
  addVar('h', 'hint_enabled');
  addVar('p', 'patm_enabled');

  return url
}